<template>
	<WebshopLoyalty v-slot="{onSubmit, loading, newIsActive, newCartTotal, newCartPercent}">
        <div v-if="newCartTotal && newCartPercent" class="cart-loyalty" :class="{'checkout-new-loyalty': mode == 'checkout'}">
            <div class="clear loyalty-w">
                <div class="loyalty-cnt" v-if="!mobileBreakpoint">
                    <div v-html="labels.get('join_loyalty').replace('%AMOUNT%', `<span class='value cart_info_total_extra_loyalty_new'>${formatCurrency(newCartTotal)}</span>`)"></div>
                </div>
                <div class="loyalty-checkbox" :class="{'loading': loading}">
                    <input type="checkbox" @click.prevent="onSubmit()" name="loyalty_request_new" id="field-loyalty_request_new" :checked="newIsActive">
                    <label for="field-loyalty_request_new" v-html="mobileBreakpoint ? labels.get('join_loyalty_label_new').replace('%AMOUNT%', `<span class='value cart_info_total_extra_loyalty_new'>${formatCurrency(newCartTotal)}</span>`) : labels.get('join_loyalty_label').replace('%AMOUNT%', `<span class='value cart_info_total_extra_loyalty_new'>${formatCurrency(newCartTotal)}</span>`)"></label>
                </div>
            </div>
        </div>	
    </WebshopLoyalty>
</template>

<script setup>
	const {mobileBreakpoint} = inject('rwd');
	const props = defineProps(['mode']);
	const labels = useLabels();

	const {formatCurrency} = useCurrency();
</script>

<style lang="less" scoped>
	.cart-loyalty{padding: 25px 30px 25px 150px; margin-bottom: 5px; border: 5px solid #D4C9DE; border-radius: var(--borderRadius);  position: relative;
		&:before{ background: url(assets/images/loyalty-kartice.svg) top left no-repeat; width: 90px; height: 56px; position: absolute; left: 30px; top: 27px; background-size: contain; content: "";}
		input[type=checkbox]+label, input[type=radio]+label{font-size: 18px; line-height: 24px; font-weight: 500;}
		&.active{border-color: var(--primaryColor);}
		@media (max-width: @l){padding: 23px 30px 23px 150px;}
		@media (max-width: @t){
			padding: 18px 24px 18px 130px; 
			&:before{width: 77px; height: 45px; left: 30px; top: 22px;}
			.loyalty-checkbox{
				input[type=checkbox]+label, input[type=radio]+label{padding: 2px 0 2px 32px; font-size: 16px !important;}
			}
		}
		@media (max-width: @m){
			padding: 20px 115px 17px 21px; margin-bottom: 5px; position: relative; border-left: unset; border-right: 0; margin-top: -12px; border-radius: unset; min-height: 93px;
			&:before{width: 88px; height: 53px; left: unset; right: 16px; top: 20px;}
			&:after{.pseudo(auto,1px); background: var(--borderColor); left: 0; right: 0; bottom: 0;}
			.loyalty-checkbox{
				input[type=checkbox]+label,input[type=radio]+label{font-size: 16px !important; padding: 3px 0 2px 30px; line-height: 20px; font-weight: normal;}
			}
		}
	}
	.loyalty-cnt{font-size: 18px; line-height: 26px; padding-bottom: 5px;
		a{text-decoration: underline !important;}
		@media (max-width: @l){font-size: 16px; line-height: 24px;}
		@media (max-width: @t){font-size: 16px; line-height: 22px;}
		@media (max-width: @m){font-size: 12px; line-height: 16px;}
	}
	:deep(.cart_info_total_extra_loyalty_new){font-weight: bold; color: var(--primaryColor);}


	//checkout
	.checkout-new-loyalty{
		margin-bottom: 20px;
		.loyalty-cnt{font-size: 16px; line-height: 23px;}
		input[type=checkbox]+label,input[type=radio]+label{font-size: 16px; line-height: 23px;}
		@media (max-width: @t){
			.loyalty-cnt{font-size: 14px; line-height: 19px;}
			input[type=checkbox]+label,input[type=radio]+label{font-size: 14px; line-height: 20px;}
		}
		@media (max-width: @tp){
			padding: 15px 15px 15px 85px;
			&:before{width: 52px; height: 32px; left: 15px; top: 14px;}
			input[type=checkbox]+label,input[type=radio]+label{font-size: 14px; line-height: 20px;}
		}
		@media (max-width: @m){
			padding: 12px 15px 12px 80px; margin-top: 0px; margin-bottom: 0;
			&:before{width: 50px; height: 30px; left: 15px; top: 8px;}
			.loyalty-cnt{font-size: 12px; line-height: 16px;}
			input[type=checkbox]+label,input[type=radio]+label{font-size: 12px; line-height: 16px;}
		}
	}
</style>